/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import GroupType from '@linc-technologies/linced-common/enums/group-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class PagesRoute extends Route {
  // Services
  @service
  session;

  @service
  store;

  model() {
    let store = this.store;

    return hash({
      pages: store.query('posts/page', {
        schoolId: this.get('session.activeSchool'),
      }),
      pageSets: store.findAll('posts/page-set'),
      templates: store.query('posts/templates/page', { isPublished: true }),
      goalSubjects: store.findAll('goals/subject'),
      tagCategories: store.findAll('posts/tag-category'),
      assessments: store.findAll('assessments/assessment'),
      autogroups: store.query('group', { groupType: GroupType.AUTO }),
    });
  }

  afterModel(model) {
    super.afterModel(...arguments);
    model.goalSubjects = model.goalSubjects
      .slice()
      .sort((a, b) => (a.label || '').localeCompare(b.label || ''));
    model.autogroups = model.autogroups
      .slice()
      .sort(
        (a, b) =>
          (a.grouping || '').localeCompare(b.grouping || '') ||
          (a.label || '').localeCompare(b.label || ''),
      );
    model.pageSets = model.pageSets
      .slice()
      .sort((a, b) => (a.label || '').localeCompare(b.label || ''));
  }
}
